var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1415 11.4811C18.1415 16.6067 11.893 21 11.893 21C11.893 21 5.64453 16.6067 5.64453 11.4811C5.64453 9.73334 6.30285 8.05714 7.47468 6.82128C8.6465 5.58541 10.2358 4.89111 11.893 4.89111C13.5502 4.89111 15.1396 5.58541 16.3114 6.82128C17.4832 8.05714 18.1415 9.73334 18.1415 11.4811Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8944 13.6775C13.0447 13.6775 13.9772 12.694 13.9772 11.4808C13.9772 10.2677 13.0447 9.28418 11.8944 9.28418C10.744 9.28418 9.81152 10.2677 9.81152 11.4808C9.81152 12.694 10.744 13.6775 11.8944 13.6775Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9086 9.03512C19.2665 8.94083 20.6493 9.65737 21.3967 10.4763C22.1442 11.2952 22.5518 12.3928 22.5299 13.5277C22.4655 16.8559 18.3419 19.6212 18.3419 19.6212C18.3419 19.6212 16.876 18.479 15.9987 17.4998",
    stroke: "currentColor",
    strokeWidth: 1.29545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70417 9.03432C4.3463 8.94111 2.964 9.65874 2.21711 10.4782C1.47023 11.2977 1.06341 12.3957 1.08615 13.5306C1.15284 16.8587 5.27837 19.6208 5.27837 19.6208C5.27837 19.6208 6.62413 18.4797 7.50073 17.4998",
    stroke: "currentColor",
    strokeWidth: 1.29545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesIcon);
export default __webpack_public_path__ + "static/media/branches-icon.0d0014a33c45cf188ba8b7715f909a72.svg";
export { ForwardRef as ReactComponent };